$(window).load(() => {
  // Footer JS Here
});
